<template>
    <div class="step-box">
        <div class="settlement">
            <div class="money">
                <span>共计</span>
                <span class="text-primary">{{info.total}}笔</span>
                <span>•</span>
                <span class="text-primary">{{info.total_money}}元</span>
            </div>
            <div class="pro-handlers">
                <el-button type="primary" size="mini" @click="queryResult"
                           :disabled="members.length === 0 || errMembers.length > 0" style="margin-right: 10px;">确认成果
                </el-button>
                <el-button type="default" @click="goPage(`/index/project/check/step1?id=${$route.query.id}`)"
                           size="mini">返回
                </el-button>
            </div>
        </div>
        <div class="data-card__box">
            <div class="data-card">
                <div class="content">
                    <i class="el-icon-caret-right" style="font-size: 10px;color:#4b74ff; "></i>
                    <span class="bd">校验成功(笔•元)</span>
                    <div class="hd">{{info.success}} • {{info.success_money}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon_xiaoyanchenggong"/>
                </div>
            </div>

            <div class="data-card">
                <div class="content">
                    <i class="el-icon-caret-right" style="font-size: 10px;color:#4b74ff; "></i>
                    <span class="bd">校验异常(笔 • 元)</span>
                    <div class="hd">{{info.fail}} • {{info.fail_money}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon_xiaoyanshibai"/>
                </div>
            </div>

            <div class="data-card">
                <div class="content">
                    <i class="el-icon-caret-right" style="font-size: 10px;color:#4b74ff; "></i>
                    <span class="bd">代缴个税合计(元)</span>
                    <div class="hd">{{info.success_tax}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon_fuwufei"/>
                </div>
            </div>

            <div class="data-card">
                <div class="content">
                    <i class="el-icon-caret-right" style="font-size: 10px;color:#4b74ff; "></i>
                    <span class="bd">待支付总额(元)</span>
                    <div class="hd">{{info.to_pay}}</div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon_daizheng"/>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table
                :data="curData"
                ref="table"
                :border="true"
                style="width: 100%;"
                :stripe="true"
            >
                <el-table-column
                    prop="no"
                    width="60"
                    align="center"
                    label="序号">
                </el-table-column>
                <el-table-column
                    prop="sub_no"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="服务编号">
                </el-table-column>
                <el-table-column
                    prop="name"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="idcard"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="身份证号">
                </el-table-column>
                <el-table-column
                    prop="amount"
                    align="center"
                    label="数量">
                </el-table-column>
                <el-table-column
                    prop="price"
                    align="center"
                    label="服务单价">
                </el-table-column>
                <el-table-column
                    prop="award"
                    align="center"
                    label="奖励金额">
                </el-table-column>
                <el-table-column
                    prop="money"
                    align="center"
                    label="服务总计">
                </el-table-column>
                <el-table-column
                    prop="to_pay"
                    align="center"
                    label="支付总额">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="180"
                    label="校验异常">
                    <template slot-scope="scope">
                        <div class="text-danger">{{scope.row.error_msg}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    fixed="right"
                    align="center">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.error_msg !== ''"
                                   @click="onDelete(scope.row.no, scope.row.error_msg)" size="medium">移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    background
                    :current-page="current"
                    layout="prev, pager, next"
                    :page-size="perPage"
                    @current-change="onPageChange"
                    :total="alldata.length">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step2',
    inject: ['goPage'],
    data () {
        return {
            members: [],
            errMembers: [],
            total_page: 1,
            info: {},
            perPage: 10,
            curData: [],
            current: 1,
            userInfo: {}
        }
    },
    computed: {
        alldata () {
            return [...this.errMembers, ...this.members]
        }
    },
    mounted () {
        let tId = this.$route.query.id
        let path = this.$route.query.path

        this.resolveExcel(tId, path)
        this.getUserInfo()
    },
    methods: {
        getUserInfo () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.userInfo = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        onPageChange (e) {
            this.current = e
            this.getData(e)
        },
        getData (e) {
            this.curData = this.alldata.slice((e - 1) * this.perPage, e * this.perPage)
        },
        onDelete (e, err) {
            if (err !== '') {
                let item = this.errMembers.filter(({ no }) => no === e)[0]
                this.errMembers = this.errMembers.filter(({ no }) => no !== e)
                this.getData(this.current)
                this.info.fail--
                this.info.total--
                this.info.fail_money = (this.info.fail_money * 1 - item.money * 1).toFixed(2)
                this.info.service_fee = (this.info.service_fee * 1 - item.service_fee * 1).toFixed(2)
                this.info.total_money = (this.info.total_money * 1 - item.money * 1).toFixed(2)
                this.info.to_pay = (this.info.to_pay * 1 - item.to_pay * 1).toFixed(2)
            }
        },
        resolveExcel (id, path) {
            this.$http.post('/api/user/project/resultsimport', qs.stringify({
                id,
                path
            }))
                .then((res) => {
                    if (res.code === 0) {
                        this.errMembers = res.data.errorData
                        this.members = res.data.listData
                        this.curData = [...this.errMembers, ...this.members].slice(0, this.perPage)
                        this.info = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        queryResult () {
            let This = this
            if (this.errMembers.length !== 0) {
                this.$message.error('请先移除异常项')
            } else if (this.members.length === 0) {
                this.$message.error('确认成果的服务不能为空')
            } else {
                if (this.info.is_overrun === 1) {
                    let arr = this.info.overrun_name.join('、')
                    let message = `${arr}单月结算额已超限，继续结算将支付超限服务费，是否继续`
                    this.$confirm(message, '存在单月结算额已超限的服务人员', {
                        confirmButtonText: '继续结算',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            This.showQueryConfirm()
                        })
                        .catch(() => {})
                } else {
                    This.showQueryConfirm()
                }
            }
        },
        showQueryConfirm () {
            const h = this.$createElement
            this.$msgbox({
                title: '服务成果确认',
                customClass: 'pay-msg-confirm',
                message: h('p', {
                    class: 'confirm-wrapper'
                }, [
                    h('i', {
                        class: ['el-icon-warning', 'text-error']
                    }),
                    h('span', {
                        class: 'confirm-text'
                    }, '请您仔细确认服务成果，一经支付，无法修改，请谨慎操作。 ')
                ]),
                showCancelButton: true,
                confirmButtonClass: 'confirm-customer-style',
                cancelButtonClass: 'confirm-customer-style',
                confirmButtonText: '确认无误',
                cancelButtonText: '返回检查'
            }).then(action => {
                this.runQueryResult()
            })
        },
        runQueryResult () {
            this.$http.post('/api/user/project/batchpaydetail', qs.stringify({
                id: this.$route.query.id,
                list: JSON.stringify(this.members)
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            message: `成功确认成果${res.data.total}项,请尽快支付。`
                        })
                        localStorage.removeItem('BATCHES')
                        localStorage.setItem('BATCHES', JSON.stringify(res.data))
                        if (this.userInfo.role_id === 2) {
                            router.replace(`/index/project/servicecommited?id=${this.$route.query.id}&sub_id=batch`)
                        } else {
                            router.replace(`/index/project/check/step3?id=${this.$route.query.id}`)
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";

    .confirm-wrapper {
        display: flex;
        padding: 20px 0;
        .text-error {
            color: $--color-danger;
            font-size: 36px;
            margin-right: 15px;
        }
        .confirm-text {
            font-size: 16px;
        }
    }

    .settlement {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 24px;
        font-size: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid $--border-color-extra-light;

        .money {
            span {
                margin-right: 10px;
            }
        }
    }

    .data-card__box {
        display: flex;
        padding: 23px 24px 18px;

        .data-card {
            flex: 1;
            background-color: $--color-white;
            display: flex;
            align-items: center;
            padding: 0 22px 0 15px;
            border-right: 1px solid $--border-color-extra-light;

            &:nth-child(4) {
                border-right: none;
            }

            .content {
                flex: 1;
                justify-content: space-around;

                .bd {
                    height: 20px;
                    font-size: 12px;
                    margin-bottom: 5px;
                    margin-left: 9px;
                }

                .hd {
                    font-size: 18px;
                    margin-top: 8px;
                    margin-left: 20px;
                }
            }

            .icon {
                .svg-icon {
                    font-size: 44px;
                }
            }
        }
    }
</style>
